import _ from "lodash";

import * as Utils from "../utils/utils";
import * as Alert from "../actions/alertActions";

import state from "../state";
import env from "../constants/env";
import PlayerPaths from "../constants/paths/playerPaths";

//import { isConnectedAndLoggedIn } from "../utils/Connectivity";
//import { getUrlForUserResource } from "./Drive";
import SyntheticVoiceApi from "../speech/SyntheticVoiceApi";
import { gotoNextItemAndSpeak, showPromptGoto, isCurrentContext, linkUrl } from "./playerActions";
import { showPromptModal, isPromptModalVisible, hidePromptModal } from "./modalActions";
import RuntimeApi from "../runtimeEngine/runtimeApi";

let moment = require("moment-timezone");

let flightTimerEnabled;
let startTime;
let elapsedTimerInterval;

export function setTimerVisible(tree, visible) {
	tree.set(["appState", "timerVisible"], visible);
}

export function toggleTimerVisible(tree) {
	tree.set(["appState", "timerVisible",], !tree.get(["appState", "timerVisible"]));
}

export function addTimerTemplate(tree, timerTemplate) {
	if (tree === null) {
		tree = state;
	}

	tree.push(["timerTemplates"], timerTemplate);

	saveTimerTemplates(tree.get(["timerTemplates"]));
}

export function saveTimerTemplates() {
	// let tree = state;

	// let user = tree.get(["lastUser"]);
	// let identityId = "";
	// if (user !== null) {
	// 	identityId = user.identityId + ":";
	// }

	/*
	store.save(identityId + "timerTemplates", timerTemplates)
		.then(() => {
			tree.set(["timerTemplates"], timerTemplates);
			// console.log("Timer templates for identity " + identityId + " saved successfully.");
			// console.log(JSON.stringify(timerTemplates));
			if (isConnectedAndLoggedIn()) {
				window.globalMyWebView.postTimerTemplatesMessage(timerTemplates, false);
			}
		})
		.catch(error => {
			console.error("Error saving timer templates to store! " + error.message);
			alert("Error saving timer templates to store! " + error.message);
		});
		*/
}

export async function createCountupTimer(tree, objTimer, context = {}) {
	// console.log("TIMERS: Create Countdown Timer");
	if (tree === null) {
		tree = state;
	}

	let now = Date.now();

	let timerKey = tree.get(["appState", "timerKey"]);
	tree.set(["appState", "timerKey"], String(Number(timerKey) + 1));

	let endTime = null;
	let repeatEndTimes = [];
	if (objTimer.repeat && objTimer.repeatCount > 0) {		

		for (let i = 1; i <= objTimer.repeatCount; i++) {
			let repeatEndTime = moment(now + ((objTimer.hours * 3600 + objTimer.minutes * 60 + objTimer.seconds) * i * 1000)).toDate();
			repeatEndTimes.push({ index: i, endTime: repeatEndTime });
		}
	} else {
		endTime = moment(now + ((objTimer.hours * 3600 + objTimer.minutes * 60 + objTimer.seconds) * 1000)).toDate();
	}

	let action;

	if (objTimer.hasOwnProperty("action") && objTimer.action.type === "link") {
		let linkUrl = "";
		if (objTimer.action.linkItemId === "") {
			linkUrl = objTimer.action.checklistId;
		} else {
			linkUrl = objTimer.action.action + ":" + objTimer.action.checklistId + ";#" + objTimer.action.linkItemId;
		}

		action = {
			"type": "link",
			"message": (objTimer.hasOwnProperty("action") && objTimer.action.hasOwnProperty("message")) ? objTimer.action.message : objTimer.message,
			"linkUrl": linkUrl,
			"checklistId": objTimer.action.checklistId,
			"linkItemId": objTimer.action.linkItemId,
			"action": objTimer.action.action
		};
	} else if (objTimer.hasOwnProperty("action") && objTimer.action.type === "message") {
		action = {
			"type": "message",
			"message": (objTimer.hasOwnProperty("action") && objTimer.action.hasOwnProperty("message")) ? objTimer.action.message : objTimer.message
		};
	}

	let essentialTimerComponents = [];
	if (objTimer.hours && objTimer.hours > 0) {
		essentialTimerComponents = [
			"hours", "minutes", "seconds"
		];
	} else {
		essentialTimerComponents = [
			"minutes", "seconds"
		];
	}

	const { guid, name, viewType, hours, minutes, seconds, repeat, repeatCount, triggers } = objTimer;

	let timer = {
		guid, name, hours, minutes, seconds, repeat, repeatCount, triggers,
		"viewType": viewType ? viewType : "",
		"type": "countup",
		"mode": objTimer.mode ? objTimer.mode : "normal",
		"hideDismiss": objTimer.hasOwnProperty("hideDismiss") ? objTimer.hideDismiss : false,
		"suppressAudio": objTimer.hasOwnProperty("suppressAudio") ? objTimer.suppressAudio : false,
		"endTime": endTime,
		"startTime": now,
		"countdownTime": "",
		"label1": objTimer.label1 ? objTimer.label1 : "",
		"label2": objTimer.label2 ? objTimer.label2 : "",
		"repeatEndTimes": repeatEndTimes,
		"enabled": true,
		"action": action,
		essentialTimerComponents,
		context
	};

	tree.set(["timers", timerKey], timer);
	tree.push("timersList", timerKey);

	if (timer.triggers && !_.isEmpty(timer.triggers)) {
		timer.triggers.forEach(trigger => {
			const { triggerTime } = trigger;
			if (triggerTime && triggerTime.after) {
				// Now determine the seconds
				const { hours, minutes, seconds } = triggerTime.after;
				const totalMilliSeconds = ((seconds ? seconds : 0) + (minutes ? minutes * 60 : 0) + (hours ? hours * 60 * 60 : 0)) * 1000;
				trigger.totalMilliSeconds = totalMilliSeconds;
				trigger.finishTimemarker = totalMilliSeconds + now;
				trigger.timerKey = timerKey;
				// console.log("Finish time marker", trigger.finishTimemarker);
			}
			pushToStartTimersQueue(trigger, timerKey);
		});
		state.set(["timers", timerKey, "triggersInitialized"], true);
	}


	// if (objTimer.hasOwnProperty("triggers")) {
	// 	objTimer.timeTargetTriggers = {};
	// 	objTimer.repeatingTimers = [];


	// }

	const totalSeconds = seconds + (minutes ? minutes * 60 : 0) + (hours ? hours * 60 * 60 : 0);
	// console.log("Setting total seconds", totalSeconds);
	state.set(["timers", timerKey, "totalSeconds"], totalSeconds);
	//await saveTimersToStore();

	startTimer(tree, timerKey, context);
}

export async function createCountdownTimer(tree, objTimer, context = {}) {
	// console.log("TIMERS: Create Countdown Timer");
	if (tree === null) {
		tree = state;
	}

	let now = Date.now();

	let timerKey = tree.get(["appState", "timerKey"]);
	tree.set(["appState", "timerKey"], String(Number(timerKey) + 1));

	let endTime = null;
	let repeatEndTimes = [];

	if (objTimer.repeat && objTimer.repeatCount > 0) {

		for (let i = 1; i <= objTimer.repeatCount; i++) {
			let repeatEndTime = moment(now + ((objTimer.hours * 3600 + objTimer.minutes * 60 + objTimer.seconds) * i * 1000)).toDate();
			repeatEndTimes.push({ index: i, endTime: repeatEndTime });
		}
	} else {
		endTime = moment(now + ((objTimer.hours * 3600 + objTimer.minutes * 60 + objTimer.seconds) * 1000)).toDate();
	}

	let action;

	if (objTimer.hasOwnProperty("action") && objTimer.action.type === "link") {
		let linkUrl = "";
		if (objTimer.action.linkItemId === "") {
			linkUrl = objTimer.action.checklistId;
		} else {
			linkUrl = objTimer.action.action + ":" + objTimer.action.checklistId + ";#" + objTimer.action.linkItemId;
		}

		action = {
			"type": "link",
			"message": (objTimer.hasOwnProperty("action") && objTimer.action.hasOwnProperty("message")) ? objTimer.action.message : objTimer.message,
			"linkUrl": linkUrl,
			"checklistId": objTimer.action.checklistId,
			"linkItemId": objTimer.action.linkItemId,
			"action": objTimer.action.action
		};
	} else if (objTimer.hasOwnProperty("action") && objTimer.action.type === "message") {
		action = {
			"type": "message",
			"message": (objTimer.hasOwnProperty("action") && objTimer.action.hasOwnProperty("message")) ? objTimer.action.message : objTimer.message
		};
	}

	let essentialTimerComponents = [];
	if (objTimer.hours && objTimer.hours > 0) {
		essentialTimerComponents = [
			"hours", "minutes", "seconds"
		];
	} else {
		essentialTimerComponents = [
			"minutes", "seconds"
		];
	}

	const { guid, name, hours, minutes, seconds, repeat, repeatCount, triggers } = objTimer;

	let timer = {
		guid, name, hours, minutes, seconds, repeat, repeatCount, triggers,
		"mode": objTimer.mode ? objTimer.mode : "normal",
		"viewType": objTimer.viewType ? objTimer.viewType : "",
		"type": "countdown",
		"label1": objTimer.label1 ? objTimer.label1 : "",
		"label2": objTimer.label2 ? objTimer.label2 : "",
		"hideDismiss": objTimer.hasOwnProperty("hideDismiss") ? objTimer.hideDismiss : false,
		"suppressAudio": objTimer.hasOwnProperty("suppressAudio") ? objTimer.suppressAudio : false,
		"endTime": endTime,
		"countdownTime": "",
		"repeatEndTimes": repeatEndTimes,
		"enabled": true,
		"action": action,
		essentialTimerComponents,
		context
	};

	tree.set(["timers", timerKey], timer);
	tree.push("timersList", timerKey);
	if (timer.triggers && !_.isEmpty(timer.triggers)) {
		timer.triggers.forEach(trigger => {
			const { triggerTime } = trigger;
			if (triggerTime && triggerTime.after) {
				// Now determine the seconds
				const { hours, minutes, seconds } = triggerTime.after;
				const totalMilliSeconds = ((seconds ? seconds : 0) + (minutes ? minutes * 60 : 0) + (hours ? hours * 60 * 60 : 0)) * 1000;
				trigger.totalMilliSeconds = totalMilliSeconds;
				trigger.finishTimemarker = totalMilliSeconds + now;
				trigger.timerKey = timerKey;
				// console.log("Finish time marker", trigger.finishTimemarker);
			}
			pushToStartTimersQueue(trigger, timerKey);
		});
		state.set(["timers", timerKey, "triggersInitialized"], true);
	}


	// if (objTimer.hasOwnProperty("triggers")) {
	// 	objTimer.timeTargetTriggers = {};
	// 	objTimer.repeatingTimers = [];


	// }

	const totalSeconds = seconds + (minutes ? minutes * 60 : 0) + (hours ? hours * 60 * 60 : 0);
	// console.log("Setting total seconds", totalSeconds);
	state.set(["timers", timerKey, "totalSeconds"], totalSeconds);
	//await saveTimersToStore();

	startTimer(tree, timerKey, context);

}

export function restartCountdownTimer(tree, timerKey) {
	if (tree === null) {
		tree = state;
	}

	let objTimer = tree.get(["timers", timerKey]);
	let endTime = moment(Date.now() + ((objTimer.hours * 3600 + objTimer.minutes * 60 + objTimer.seconds) * 1000)).toDate();

	objTimer.endTime = endTime;
	objTimer.enabled = true;

	if (objTimer.type === "countup") {
		objTimer.startTime = Date.now();
	}

	tree.set(["timers", timerKey], objTimer);

	startTimer(tree, timerKey);
}

export async function createAlarmTimer(tree, objTimer) {
	if (tree === null) {
		tree = state;
	}

	let timerKey = tree.get(["appState", "timerKey"]);
	tree.set(["appState", "timerKey"], String(Number(timerKey) + 1));

	let endTime = moment(objTimer.alarmDateTime).toDate();

	let timer = {
		"name": objTimer.name,
		"type": "alarm",
		"endTime": endTime,
		"countdownTime": "",
		"repeat": false,
		"enabled": true,
		"action": {
			"type": "message",
			"message": objTimer.message
		}
	};

	tree.set(["timers", timerKey], timer);
	tree.push("timersList", timerKey);

	//await saveTimersToStore();

	startTimer(tree, timerKey);
}

export function cancelTimersInContext(context = null) {
	if (context) {
		// console.log("cancelTimersInContext:", context, state.get(["timers"]));
		// Find timers that match the provided context

		const timerKeys = state.get(["timersList"]);
		const contextKeys = _.keys(context);
		const contextEntries = contextKeys.length;

		// console.log("cancelTimersInContext:", contextKeys, contextEntries);

		timerKeys.forEach(timerKey => {
			const timer = state.get(["timers", timerKey]);
			let matches = 0;
			if (timer.context) {
				contextKeys.forEach(key => {
					if (context[key] === timer.context[key]) {
						matches++;
					}
				});
			}
			if (matches === contextEntries) {
				// console.log("cancelTimersInContext: Need to cancel timer", timer);
				deleteTimer(state, timerKey);
			} else {
				// console.log("cancelTimersInContext: Insufficient matches", timer.context, timerKeys, state.get(["timers"]), context);
			}
		});

	}
}

function startTimer(tree, timerKey, context = null) {

	// console.log("TIMERS: Start Timer", timerKey);
	if (tree === null) {
		tree = state;
	}
	const objTimer = tree.get(["timers", timerKey]);
	// console.log("Start timer context", context);
	if (context) {
		objTimer.context = context;
	}

	if (objTimer.mode === "modal") {
		tree.set(["appState", "timerModalVisible"], true);
	}

	if (objTimer.repeat && objTimer.repeatCount > 0) {
		setTimerVisible(tree, true);

		for (let i = 0; i < objTimer.repeatEndTimes.length; i++) {
			// let endTime = objTimer.repeatEndTimes[i].endTime;

			// console.log("localNotificationSchedule: " + timerKey + String(objTimer.repeatEndTimes[i].index));

			delete objTimer.endTime;

			/*
			PushNotification.localNotificationSchedule({
				id: timerKey + String(objTimer.repeatEndTimes[i].index),
				userInfo: {
					id: timerKey + String(objTimer.repeatEndTimes[i].index),
					timer: objTimer
				},
				message: objTimer.action && objTimer.action.message !== "" ? objTimer.action.message : "Timer Complete",
				date: endTime
			});
			*/
		}
	} else {
		let t = getTimeRemaining(objTimer.endTime);
		if (t.total > 0) {
			setTimerVisible(tree, true);

			timerKey = String(Number(timerKey));
			// console.log("localNotificationSchedule: " + timerKey);

			/*
			PushNotification.localNotificationSchedule({
				id: timerKey,
				userInfo: {
					id: timerKey,
					timer: objTimer
				},
				message: objTimer.action && objTimer.action.message !== "" ? objTimer.action.message : "Timer Complete",
				date: objTimer.endTime
			});
			*/
		}
	}
}

export async function deleteTimer(tree = state, timerKey) {

	let timersList = tree.get(["timersList"]);

	let keyIndex = _.findIndex(timersList, function (o) { return o === timerKey; });
	if (keyIndex >= 0) {
		tree.splice(["timersList"], [keyIndex, 1]);


		let timer = tree.get(["timers", timerKey]);

		if (timer.mode === "modal") {
			tree.set(["appState", "timerModalVisible"], false);
		}

		if (timer && timer !== null) {

			if (timer.repeat && timer.repeatCount > 0) {
				for (let i = 0; i < timer.repeatEndTimes.length; i++) {
					// let endTime = timer.repeatEndTimes[i];
					// console.log("cancelLocalNotifications: " + timerKey + String(endTime.index));
					//PushNotification.cancelLocalNotifications({ id: timerKey + String(endTime.index) });
				}
			} else {
				timerKey = String(Number(timerKey));
				// console.log("cancelLocalNotifications: " + timerKey);
				//PushNotification.cancelLocalNotifications({ id: timerKey });
			}

			tree.unset(["timers", timerKey]);
			let newTriggers = {};
			let triggers = tree.get(["triggers"]);

			_.keys(triggers).forEach(key => {
				const trigger = triggers[key];
				if (trigger.timerKey !== String(timerKey)) {
					newTriggers[key] = trigger;
				}
			});
			// console.log("Setting new triggers", newTriggers, "old triggers were", triggers);
			tree.set(["triggers"], newTriggers);
		}

		/*
		try {
			await saveTimersToStore();
			await saveTriggersToStore();
		} catch (err) {
			alert("Error: " + err.message);
		}
		*/
	}
}


async function saveTriggersToStore() {
	/*
	// console.log("Save triggers");
	let tree = state;
	let user = tree.get(["lastUser"]);
	let identityId = "";
	if (user !== null) {
		identityId = user.identityId + ":";
	}
	let triggers = tree.get(["triggers"]);
	await store.save(identityId + "triggers", triggers ? triggers : {});
	*/
}

export function deleteTimerByIndex(tree, index) {
	if (tree === null) {
		tree = state;
	}

	let timersList = tree.get(["timersList"]);

	for (let i = 0; i < timersList.length; i++) {
		if (i === index) {
			let timerKey = timersList[i];

			deleteTimer(tree, timerKey);
		}
	}
}

export function deleteAllTimers(tree) {
	if (tree === null) {
		tree = state;
	}

	let timersList = tree.get(["timersList"]);

	for (let i = 0; i < timersList.length; i++) {
		let timerKey = timersList[i];

		deleteTimer(tree, timerKey);
	}
	tree.set(["triggers"], {});
	//saveTriggersToStore();
}

export function removePassedTimers(tree) {
	if (tree === null) {
		tree = state;
	}

	let timersList = tree.get(["timersList"]);

	for (let i = 0; i < timersList.length; i++) {
		let timerKey = timersList[i];

		let objTimer = tree.get(["timers", timerKey]);

		if (objTimer && objTimer !== null) {
			// console.log(objTimer);

			let expiredCount = 0;
			if (objTimer.repeat && objTimer.repeatCount > 0) {
				for (let j = 0; j < objTimer.repeatEndTimes.length; j++) {
					let endTime = objTimer.repeatEndTimes[j].endTime;
					let t = getTimeRemaining(endTime);
					if (t.total < 0) {
						expiredCount++;
					}
				}

				// Remove timers that expired
				for (let k = 0; k < expiredCount; k++) {
					objTimer.repeatEndTimes.shift();
				}

				// If none left, delete entire timer
				if (objTimer.repeatEndTimes.length === 0) {
					tree.set(["timers", timerKey], objTimer);
					deleteTimer(tree, timerKey);
				}
			} else {
				let t = getTimeRemaining(objTimer.endTime);
				if (t.total < 0) {
					deleteTimer(tree, timerKey);
				}
			}
		} else {
			deleteTimer(tree, timerKey);
		}
	}
}

export function getTimerObject(timerKey) {
	return state.get(["timers", timerKey]);
}

async function isPushNotificationActive() {
	let result = false;
	/*
	const permissions = await getPushNotificationPermissions();
	_.forEach(permissions, (value, index) => {
		result = result || value;
	});
	*/
	return result;
}

// function getPushNotificationPermissions() {
// 	/*
// 	return new Promise((resolve, reject) => {
// 		try {
// 			PushNotification.checkPermissions((permissions) => {
// 				resolve(permissions);
// 			});
// 		} catch (e) {
// 			reject(e);
// 		}
// 	})
// 	*/
// }

export async function handlePostTimerCompleteIfNoPushNotifications(timer, timerKey) {
	const pushNotificationsActive = await isPushNotificationActive();
	if (!pushNotificationsActive) {
		console.log("NO PUSH NOTIFICATION!");
		handlePostTimerComplete(timer, timerKey);
	}
}

export function handlePostTimerComplete(timer, timerKey, prompt = false) {
	console.log("handlePostTimerComplete", timer,prompt);
	return new Promise((resolve) => {
		if (timer && timer.mode === "modal") {
			setTimeout(() => {
				deleteTimer(state, timerKey);
				if (timer.action && timer.action.type !== "link") { // COMMENT BACK IN!
					// If this isn"t a link then default to moving to the next item
					const { activityId, listIndex, sectionIndex, itemIndex } = timer.context;
					const _isCurrentContext = isCurrentContext(activityId, listIndex, sectionIndex, itemIndex);
					if (_isCurrentContext) {
						// If the modal was dismissed and the user moved on then don"t try to perform the default navigation
						setTimeout(() => {
							gotoNextItemAndSpeak(timer.context);
							resolve();
						}, 200);
					} else {
						resolve();
					}

				} else {
					handleTimerAction(timer, resolve);
				}
			}, 4000);
		} else if (timer && timer.action) {
			handleTimerAction(timer, resolve);
		}
	});

}

function handleTimerAction(timer, resolve) {
	if (!timer || !timer.action) {
		resolve();
		return;
	}
	switch (timer.action.type) {
		case "link": {
			// Could set this on state and process at end of componentDidMount
			//self.context.tree.set(["appState","goto"],notification.data.timer);    
			console.log("Link timer with mode", timer.mode);
			setTimeout(() => {
				showPromptGoto(state, timer);
				resolve();
			}, 200);
			break;
		}
		default: {
			resolve();
			console.warn("Unknown timer action type:", timer.action.type);
		}
	}
}

export async function saveTimersToStore() {
	// let tree = state;
	// let user = tree.get(["lastUser"]);
	// let identityId = "";
	// if (user !== null) {
	// 	identityId = user.identityId + ":";
	// }

	//await store.save(identityId + "timers", tree.get(["timers"]));
	//await store.save(identityId + "timersList", tree.get(["timersList"]));
}


// let timerTemplatesFileCache = {};
// let timerTemplatesCache = {};

export function fetchMissingTimers(activity) {
	return new Promise(async (resolve, reject) => { // eslint-disable-line
		let missingTimerTemplates = [];
		// console.log("Find missing timers", activity);
		getMissingTimerTemplates(activity, missingTimerTemplates);
		console.debug("Found missing timers", missingTimerTemplates);

		const playerActivities = state.get(PlayerPaths.ACTIVITIES);
		console.log("Start new activity", playerActivities);

		let identityId = "";
		for (let i = 0; i < playerActivities.length; i++) {
			const playerActivity = playerActivities[i];

			if (playerActivity.id === activity.id) {
				identityId = playerActivity.identityId;
				break;
			}
		}

		const missingTimerTemplatesFetchPromises = [];
		missingTimerTemplates.forEach(timerKey => {
			missingTimerTemplatesFetchPromises.push(retrieveMissingTimer(identityId, timerKey));
		});

		try {
			const timers = await Promise.all(missingTimerTemplatesFetchPromises);
			// Add them to the timerTemplates
			let currentTimerTemplates = state.get(["timerTemplates"]);
			if (!currentTimerTemplates || !_.isArray(currentTimerTemplates)) {
				currentTimerTemplates = [];
				state.set(["timerTemplates"], currentTimerTemplates);
			}
			const currentTimerTemplatesMap = {};
			currentTimerTemplates.forEach(tt => {
				currentTimerTemplatesMap[tt.guid] = tt;
			});
			console.log("Current timer templates map", currentTimerTemplatesMap);
			timers.forEach(timer => {
				// Make sure we don"t add them multiple times!
				if (timer && !currentTimerTemplatesMap[timer.guid]) {
					// Don"t want these timers to be synced to the current users inventory, as they don"t own them
					const _timer = _.assign({}, timer, {
						excludeFromSync: true
					});
					state.push(["timerTemplates"], _timer);
				}
			});
			resolve();
		} catch (err) {
			console.error("An error occurred while attempting to fetch missing timers", err);
			reject(err);
		}

	});
}

/*
function retrieveMissingTimer(identityId, timerKey) {
	return new Promise(async (resolve, reject) => {
		try {
			const fileKey = `${identityId}/timers/${timerKey}.json`;
			if (timerTemplatesCache[fileKey]) {
				resolve(timerTemplatesCache[fileKey]);
			} else {
				const url = getUrlForUserResource(`${identityId}/timers/${timerKey}.json`);
				// console.log("About to fetch", url);
				const res = await fetch(url);
				if (res.ok) {
					// console.log("RES", res);
					const resJson = await res.json();
					timerTemplatesCache[fileKey] = resJson;
					resolve(resJson);
				} else {
					// Try to get full inventory
					const fileKey = `${identityId}/timerTemplates.json`;
					const url = getUrlForUserResource(fileKey);
					// console.debug("Attemting a fetch on timer inventopry");
					let timerTemplates = timerTemplatesFileCache[fileKey];
					if (!timerTemplates) {
						const res = await fetch(url);
						timerTemplates = await res.json();
					}

					if (timerTemplates && _.isArray(timerTemplates)) {
						timerTemplatesFileCache[fileKey] = timerTemplates;
						const result = _.find(timerTemplates, (o) => { return o.guid === timerKey; });
						if (result) {
							timerTemplatesCache[`${identityId}/timers/${timerKey}.json`] = result;
							resolve(result);
						} else {
							reject({
								success: false,
								message: "Unable to find timer template in inventory",
								inventory: timerTemplates,
								timerKey,
								fileKey
							})
						}
					} else {
						reject({
							success: false,
							message: "The timer inventory is invalid, expected an array of timers",
							inventory: timerTemplates,
							timerKey,
							fileKey
						})
					}
				}

			}
		} catch (err) {
			console.warn("Failed to get timer templates (fatal error)", err);
			reject(err);
		}
	});
}
*/

// JJB: Keeps crashing in here on preview - trying to add more resiliency
function getMissingTimerTemplates(node, missingTimerTemplates = [], missingGuids = {}) {
	if (node && node.hasOwnProperty("startNamedTimers")) {
		if (_.isArray(node.startNamedTimers) && node.startNamedTimers.length > 0) {
			node.startNamedTimers.forEach(timer => {
				const timerKey = timer.value;
				if (!missingGuids[timerKey]) {
					if (!timerKey.startsWith("#internal-timer:") && !timerKey.startsWith("internal-timer-")) {
						// External timer
						const objTimer = _.find(state.get(["timerTemplates"]), (o) => { return o.guid === timerKey; });
						if (!objTimer) {
							missingGuids[timerKey] = true;
							missingTimerTemplates.push(timerKey);
						}
					}
				}
			});
		}
	}

	if (node && node.hasOwnProperty("children")) {
		if (_.isArray(node.children) && node.children.length > 0) {
			node.children.forEach(child => {
				getMissingTimerTemplates(child, missingTimerTemplates, missingGuids);
			});
		}
	}
}

// TODO: Could promisify then reuse from Utils
// export function restoreTimersFromStore() {
// 	let tree=state;

// 	let user = tree.get(["lastUser"]);
// 	let identityId = "";
// 	if (user != null) {
// 		identityId = user.identityId + ":";
// 	}

// 	store.get(identityId + "timersList")
// 	.then(timersList => {
// 		if (timersList === null) {
// 			tree.set(["timersList"],[]);
// 			tree.set(["timers"],{});
// 		} else {
// 			tree.set(["timersList"],timersList);

// 			store.get(identityId + "timers")
// 			.then(timers => {
//                 debugger;
// 				tree.set(["timers"],timers);

// 				// Clean up ones that have passed
// 				removePassedTimers(tree);

// 				timersList = tree.get(["timersList"]);

// 				if (timersList.length > 0) {
// 					setTimerVisible(tree, true);
// 				}
// 			})
// 			.catch(error => {
// 				// console.log("Error getting timers from store! " + error.message);
// 			})
// 		}
// 	})
// 	.catch(error => {
// 		// console.log("Error getting timers from store! " + error.message);
// 	})
// }



let intervalId;

export function startClock(tree) {
	// console.log(" In " + arguments.callee.name);
	if (!intervalId) {
		handleTimerTick(tree);
		intervalId = setInterval(function () { handleTimerTick(tree); }, 1000);
	}
}


export function startFlightTimer(tree) {
	// console.log(" In " + arguments.callee.name);
	let currentTime = moment();

	let time = currentTime.tz(moment.tz.guess()).format("YYYY-MM-DD hh:mm A z") + " (" + currentTime.utc().format("YYYY-MM-DD HH:mm") + " UTC)";
	let timeUtc = currentTime.toISOString();
	let timeLocale = currentTime.format();

	//tree.set(["logbook","timeIn"],time);
	tree.set(["activity", "logbook", "timeOut"], time);
	tree.set(["activity", "logbook", "timeOutLocale"], timeLocale);
	tree.set(["activity", "logbook", "timeOutUtc"], timeUtc);

	//saveCurrentChecklistToStore(tree);
	flightTimerEnabled = true;
	startTime = Date.now();
	elapsedTimerInterval = setInterval(function () { handleElapsedTimerTick(tree); }, 1000);
}

export function stopFlightTimer(tree) {
	// console.log(" In " + arguments.callee.name);
	let currentTime = moment();

	let time = currentTime.tz(moment.tz.guess()).format("YYYY-MM-DD hh:mm A z") + " (" + currentTime.utc().format("YYYY-MM-DD HH:mm") + " UTC)";
	let timeUtc = currentTime.toISOString();
	let timeLocale = currentTime.format();

	//tree.set(["logbook","timeIn"],time);
	tree.set(["activity", "logbook", "timeIn"], time);
	tree.set(["activity", "logbook", "timeInLocale"], timeLocale);
	tree.set(["activity", "logbook", "timeInUtc"], timeUtc);
	flightTimerEnabled = false;
	clearInterval(elapsedTimerInterval);
	tree.set(["activity", "logbook", "elapsed"], moment.duration(((Date.now() - startTime) / 1000) / 60, "minutes").format("h [Hours]", 1));
	//saveCurrentChecklistToStore(tree);
}

function executeActions(actions) {
	let timerKey; //TODO: doesn't seem to be set anywhere
	if (actions) {
		actions.forEach(action => {
			switch (action.type) {
				case "message": {
					// console.log("MESSAGE", action.message);
					break;
				}
				case "setProperty": {
					state.set(["timers", timerKey, action.prop], action.value);
					break;
				}
				case "showModal": {
					break;
				}
				default: {
					console.warn("Unknown action.type", action);
				}
			}
		});
	}
}

function handleTriggers(timer, timerKey, elapsedTime) { // eslint-disable-line
	console.log("Handle triggers", timer, timerKey, elapsedTime);
	if (timer) {
		const key = `s${elapsedTime}`;
		if (timer.timeTargetTriggers && timer.timeTargetTriggers[key]) {
			executeActions(timer.timeTargetTriggers[key].actions);
		}
	}
}

// function initTriggers(timer, timerKey) {
// 	if (!timer.triggersInitialized) {
// 		timer.triggers.forEach(trigger => {
// 			const { triggerTime,actions } = trigger;
// 			if (triggerTime) {
// 				if (triggerTime.after) {
// 					// Now determine the seconds
// 					const { hours, minutes, seconds } = triggerTime.after;
// 					const totalMilliSeconds = ((seconds ? seconds : 0 + minutes ? minutes * 60 : 0 + hours ? hours * 60 * 60 : 0)-1)*1000;
// 					const timerId = setTimeout(() => {
// 						if (actions) {
// 							actions.forEach(action => {
// 								switch (action.type) {
// 									case "message": {
// 										console.log("MESSAGE", action.message);
// 										break;
// 									}
// 									case "setProperty": {
// 										state.set(["timers", timerKey, action.prop], action.value);
// 										break;
// 									}
// 									default: {
// 										console.warn("Unknown action.type", action);
// 									}
// 								}
// 							});
// 						}
// 					}, totalMilliSeconds);
// 				}
// 			}
// 		});
// 		state.set(["timers", timerKey, "triggersInitialized"], true);
// 	}
// }
let timerQueue = [];
export function pushToStartTimersQueue(trigger, timerKey) {
	trigger.timerKey = timerKey;
	timerQueue.push(trigger);

}

function startTimersQueue() {
	let trigger = null;
	// console.log("startTimersQueue");
	let needsSave = false;
	while (trigger = timerQueue.pop()) { // eslint-disable-line
		// console.log("Popping func");
		needsSave = true;
		// consfunc();
		const { actions, timerKey, finishTimemarker } = trigger;

		console.log(`Setting ["triggers",${finishTimemarker}]`, {
		 	trigger, actions, timerKey
		});
		state.set(["triggers", finishTimemarker], {
			trigger,
			actions,
			timerKey
		});


	}
	if (needsSave) {
		saveTriggersToStore();
	}
}

function executeAction(action, timerKey) {
	if (action && _.isString(action.type)) {
		// console.log("Triggering action", action);
		switch (action.type) {
			case "message": {
				// console.log("MESSAGE", action.message);
				alert(action.text);
				break;
			}
			case "speakText": {
				try {
					SyntheticVoiceApi.stop();
				} catch (e) {
					console.warn(e);
				}
				SyntheticVoiceApi.speak(action.text);
				break;
			}
			case "conditional-actions": {

				const { behavior, actions } = action;

				if (behavior && actions && _.isArray(actions)) {


					let n = actions.length;

					for (let i = 0; i < n; i++) {
						const action = actions[i];
						const { condition, conditionEvalType } = action;
						let _executeAction = false;

						switch (conditionEvalType) {
							case "function": {
								let AmbiFi = RuntimeApi;// eslint-disable-line
								let af = RuntimeApi; // eslint-disable-line
								let afState = state; // eslint-disable-line
								let afUtils = Utils; // eslint-disable-line
								let afAlert = Alert; // eslint-disable-line
								// console.log("Evaluating condition", condition);
								_executeAction = eval(condition);// eslint-disable-line
								// console.log("Execute?", _executeAction);
								break;
							}
							default: {
								console.error("Unknown conditional eval type", conditionEvalType);
							}
						}

						if (_executeAction) {
							action.actions.forEach(_action => {
								executeAction(_action, timerKey);
							});
							// Exxecute the action
							if (behavior === "execute-first") {
								break;
							}
						}

					}

				} else {
					console.error("Expecting an array of actions and a valid behavior for conditional actions");
				}


				break;
			}
			case "setProperty": {
				// console.log("setProperty", timerKey, action.prop, action.value);
				state.set(["timers", timerKey, action.prop], action.value);
				break;
			}
			case "showModal": {
				const { text, affirmativeActions, affirmativeLabel, negativeLabel, negativeActions } = action;
				if (text && affirmativeActions) {

					let options = {};
					if (affirmativeLabel) {
						options.affirmativeLabel = affirmativeLabel;
					}
					if (negativeLabel) {
						options.negativeLabel = negativeLabel;
					}

					
					if (isPromptModalVisible()) {
						hidePromptModal();
					}

					showPromptModal(text, () => {
						// console.log("Performing affirmative actions");
						affirmativeActions.forEach(_action => {
							executeAction(_action, timerKey);
						});
					}, () => {
						if (negativeActions) {
							negativeActions.forEach(_action => {
								executeAction(_action, timerKey);
							});
						}
					}, options);					
				} else {
					console.error("Expected action to have follow up affirmativeActions and text to show to the user");
				}

				break;
			}
			case "link": {
				try {

					linkUrl(state, action.linkUrl);
				} catch (err) {
					console.error(err);
				}
				break;
			}
			default: {
				console.warn("Unknown action.type", action);
			}
		}
	}
}

async function executeTrigger(trigger, actions, timerKey) {
	// console.log("Executing trigger", trigger, actions);
	if (actions) {
		actions.forEach(action => {
			executeAction(action, timerKey);
		});
	}
	console.log("UNSET TRIGGER", trigger.finishTimemarker, state.get(["triggers"]));
	state.unset(["triggers", trigger.finishTimemarker]);
	await saveTriggersToStore();
}

function executeTriggers(refTime) {
	const triggers = state.get(["triggers"]);
	_.keys(triggers).forEach(async key => {
		if (key <= refTime) {
			// console.log("Executing trigger", refTime, key);
			const { trigger, actions, timerKey } = triggers[key];
			await executeTrigger(trigger, actions, timerKey);
		}
	});
}


function allTimersComplete(tree, timersList) {
	let allDone = true;

	for (let i = 0; i < timersList.length; i++) {
		let timerKey = timersList[i];

		let timers = tree.get(["timers"]);

		if (timers.hasOwnProperty(timerKey)) {
			let objTimer = tree.get(["timers", timerKey]);
			if (objTimer && objTimer.countdownSecondsRemaining > 0) {
				allDone = false;
			}
		}
	}

	return allDone;
}

function handleTimerTick(tree) {
	const refTime = new Date().getTime();
	startTimersQueue(refTime);
	executeTriggers(refTime);
	//// console.log(" In " + arguments.callee.name);
	let currentTime = moment();

	tree.set(["flightTimer", "clock"], currentTime.tz(moment.tz.guess()).format("hh:mm:ss A z"));
	tree.set(["flightTimer", "clockUTC"], currentTime.utc().format("HH:mm:ss") + " UTC");

	// Loop through timers and update them
	let timersList = tree.get(["timersList"]);

	if (timersList.length === 0) {
		tree.set(["timers", "timerActive"], false);
		return;
	}

	for (let i = 0; i < timersList.length; i++) {
		let timerKey = timersList[i];

		let objTimer = tree.get(["timers", timerKey]);
		// console.log(objTimer);
		// TODO!!! If currents time is later than endTime of timer then remove it
		if (objTimer && objTimer.enabled) {
			// Deal with Repeat timers...array of repeat endTimes
			if (objTimer.repeat) {
				tree.set(["timers", "timerActive"], true);

				// console.log("Repeat")
				if (objTimer.repeatEndTimes.length > 0) {
					// console.log("repeatEndTimes > 0");
					let endTime = objTimer.repeatEndTimes[0].endTime;

					let t = objTimer.type === "countup" ? getTimeElapsed(objTimer.startTime) : getTimeRemaining(endTime);

					let formatTime;

					if (objTimer.type === "countdown") {
						if (t.days > 0) {
							formatTime = Utils.zeroPrefix(t.days) + ":" + Utils.zeroPrefix(t.hours) + ":" + Utils.zeroPrefix(t.minutes) + ":" + Utils.zeroPrefix(t.seconds);
						} else if (t.hours > 0) {
							formatTime = Utils.zeroPrefix(t.hours) + ":" + Utils.zeroPrefix(t.minutes) + ":" + Utils.zeroPrefix(t.seconds);
						} else if (t.minutes > 0) {
							formatTime = Utils.zeroPrefix(t.minutes) + ":" + Utils.zeroPrefix(t.seconds);
						} else {
							formatTime = t.seconds;
						}
					} else {
						formatTime = Utils.zeroPrefix(t.hours) + ":" + Utils.zeroPrefix(t.minutes) + ":" + Utils.zeroPrefix(t.seconds);
					}

					const elapsedTime = tree.get(["timers", timerKey, "elapsedTime"]);
					tree.set(["timers", timerKey, "elapsedTime"], elapsedTime ? elapsedTime + 1 : 0);
					// handleTriggers(objTimer, timerKey, elapsedTime);


					if (objTimer.type === "countup") {
						const totalTimeInMillies = objTimer.totalSeconds * 1000;
						if (t.total === totalTimeInMillies) {
							if (!objTimer.hasOwnProperty("suppressAudio") || !objTimer.suppressAudio) {
								speakTimerMessage(tree, timerKey);
							}

							tree.set(["timers", timerKey, "countdownTime"], tree.get(["timers", timerKey, "action", "message"]));
							tree.set(["timers", timerKey, "countdownSecondsRemaining"], 0);
						} else if (t.total > totalTimeInMillies) {
							tree.shift(["timers", timerKey, "repeatEndTimes"]);
							tree.set(["timers", timerKey, "countdownSecondsRemaining"], 0);
						} else {
							tree.set(["timers", timerKey, "countdownTime"], formatTime);
							// console.log(Utils.zeroPrefix(t.days) + ":" + Utils.zeroPrefix(t.hours) + ":" + Utils.zeroPrefix(t.minutes) + ":" + Utils.zeroPrefix(t.seconds));
							let countdownTimeEssential = [];
							if (objTimer.essentialTimerComponents) {
								objTimer.essentialTimerComponents.forEach(comp => {
									countdownTimeEssential.push(Utils.zeroPrefix(t[comp]));
								});
							}
							tree.set(["timers", timerKey, "countdownTimeEssential"], countdownTimeEssential.join(":"));
							tree.set(["timers", timerKey, "countdownSecondsRemaining"], ((t.day ? t.day * 24 * 60 * 60 : 0) + (t.hours ? t.hours * 60 * 60 : 0) + (t.minutes ? t.minutes * 60 : 0) + (t.seconds ? t.seconds : 0)));
						}
					} else {
						if (t.seconds % 10 === 0 && t.seconds !== 0 && t.minutes < 1) {
							// console.log("Remaining (repeat)", t.seconds, timerKey);
							SyntheticVoiceApi.speak(t.seconds + " seconds remaining");
						} else if (t.seconds <= 10 && t.seconds !== 0 && t.minutes < 1) {
							// console.log("Remaining (repeat)", t.seconds, timerKey);
							// SyntheticVoiceApi.speak("" + t.seconds);
						}
						if (t.total === 0) {
							if (!objTimer.hasOwnProperty("suppressAudio") || !objTimer.suppressAudio) {
								speakTimerMessage(tree, timerKey);
							}

							tree.set(["timers", timerKey, "countdownTime"], tree.get(["timers", timerKey, "action", "message"]));
							tree.set(["timers", timerKey, "countdownSecondsRemaining"], 0);
						} else if (t.total < 0) {
							tree.shift(["timers", timerKey, "repeatEndTimes"]);
							tree.set(["timers", timerKey, "countdownSecondsRemaining"], 0);
						} else {
							tree.set(["timers", timerKey, "countdownTime"], formatTime);
							// console.log(Utils.zeroPrefix(t.days) + ":" + Utils.zeroPrefix(t.hours) + ":" + Utils.zeroPrefix(t.minutes) + ":" + Utils.zeroPrefix(t.seconds));
							let countdownTimeEssential = [];
							if (objTimer.essentialTimerComponents) {
								objTimer.essentialTimerComponents.forEach(comp => {
									countdownTimeEssential.push(Utils.zeroPrefix(t[comp]));
								});
							}
							tree.set(["timers", timerKey, "countdownTimeEssential"], countdownTimeEssential.join(":"));
							tree.set(["timers", timerKey, "countdownSecondsRemaining"], ((t.day ? t.day * 24 * 60 * 60 : 0) + (t.hours ? t.hours * 60 * 60 : 0) + (t.minutes ? t.minutes * 60 : 0) + (t.seconds ? t.seconds : 0)));
						}
					}

				} else {
					tree.set(["timers", "timerActive"], !allTimersComplete(tree, timersList));

					tree.set(["timers", timerKey, "enabled"], false);
					tree.set(["timers", timerKey, "countdownTime"], "Timer Complete");
					tree.set(["timers", timerKey, "countdownSecondsRemaining"], 0);
					// speakTimerMessage(tree, timerKey);

					handlePostTimerCompleteIfNoPushNotifications(objTimer, timerKey);

				}
			} else {
				tree.set(["timers", "timerActive"], true);

				// console.log("No repeat",objTimer);
				let t = objTimer.type === "countup" ? getTimeElapsed(objTimer.startTime) : getTimeRemaining(objTimer.endTime);

				let formatTime;

				if (objTimer.type === "countdown") {
					if (t.days > 0) {
						formatTime = Utils.zeroPrefix(t.days) + ":" + Utils.zeroPrefix(t.hours) + ":" + Utils.zeroPrefix(t.minutes) + ":" + Utils.zeroPrefix(t.seconds);
					} else if (t.hours > 0) {
						formatTime = Utils.zeroPrefix(t.hours) + ":" + Utils.zeroPrefix(t.minutes) + ":" + Utils.zeroPrefix(t.seconds);
					} else if (t.minutes > 0) {
						formatTime = Utils.zeroPrefix(t.minutes) + ":" + Utils.zeroPrefix(t.seconds);
					} else {
						formatTime = t.seconds;
					}
				} else {
					formatTime = Utils.zeroPrefix(t.hours) + ":" + Utils.zeroPrefix(t.minutes) + ":" + Utils.zeroPrefix(t.seconds);
				}

				if (objTimer.type === "countup") {
					const totalTimeInMillies = objTimer.totalSeconds * 1000;
					// console.log("countup", t.total, objTimer.totalSeconds);
					tree.set(["timers", timerKey, "countdownTime"], formatTime);
					// console.log(Utils.zeroPrefix(t.days) + ":" + Utils.zeroPrefix(t.hours) + ":" + Utils.zeroPrefix(t.minutes) + ":" + Utils.zeroPrefix(t.seconds));
					let countdownTimeEssential = [];
					if (objTimer.essentialTimerComponents) {
						objTimer.essentialTimerComponents.forEach(comp => {
							countdownTimeEssential.push(Utils.zeroPrefix(t[comp]));
						});
					}
					const elapsedTime = tree.get(["timers", timerKey, "elapsedTime"]);
					tree.set(["timers", timerKey, "elapsedTime"], elapsedTime ? elapsedTime + 1 : 0);

					// handleTriggers(objTimer, timerKey, elapsedTime);

					tree.set(["timers", timerKey, "countdownTimeEssential"], countdownTimeEssential.join(":"));
					tree.set(["timers", timerKey, "countdownSecondsRemaining"], ((t.day ? t.day * 24 * 60 * 60 : 0) + (t.hours ? t.hours * 60 * 60 : 0) + (t.minutes ? t.minutes * 60 : 0) + (t.seconds ? t.seconds : 0)));

					if (t.total >= totalTimeInMillies) {
						tree.set(["timers", "timerActive"], !allTimersComplete(tree, timersList));

						tree.set(["timers", timerKey, "enabled"], false);

						if (!objTimer.hasOwnProperty("suppressAudio") || !objTimer.suppressAudio) {
							speakTimerMessage(tree, timerKey);
						}

						tree.set(["timers", timerKey, "countdownTime"], tree.get(["timers", timerKey, "action", "message"]));
						tree.set(["timers", timerKey, "countdownSecondsRemaining"], 0);

						handlePostTimerCompleteIfNoPushNotifications(objTimer, timerKey);
					}
				} else {
					// console.log("countdown");
					if (t.seconds % 10 === 0 && t.seconds !== 0 && t.minutes < 1) {
						// console.log("Remaining", t.seconds, timerKey, i);
						SyntheticVoiceApi.speak(t.seconds + " seconds remaining");
					} else if (t.seconds <= 10 && t.seconds !== 0 && t.minutes < 1) {
						// console.log("Remaining", t.seconds, timerKey, i);
						// SyntheticVoiceApi.speak("" + t.seconds);
					}

					tree.set(["timers", timerKey, "countdownTime"], formatTime);
					// console.log(Utils.zeroPrefix(t.days) + ":" + Utils.zeroPrefix(t.hours) + ":" + Utils.zeroPrefix(t.minutes) + ":" + Utils.zeroPrefix(t.seconds));
					let countdownTimeEssential = [];
					if (objTimer.essentialTimerComponents) {
						objTimer.essentialTimerComponents.forEach(comp => {
							countdownTimeEssential.push(Utils.zeroPrefix(t[comp]));
						});
					}
					const elapsedTime = tree.get(["timers", timerKey, "elapsedTime"]);
					tree.set(["timers", timerKey, "elapsedTime"], elapsedTime ? elapsedTime + 1 : 0);

					// handleTriggers(objTimer, timerKey, elapsedTime);

					tree.set(["timers", timerKey, "countdownTimeEssential"], countdownTimeEssential.join(":"));
					tree.set(["timers", timerKey, "countdownSecondsRemaining"], ((t.day ? t.day * 24 * 60 * 60 : 0) + (t.hours ? t.hours * 60 * 60 : 0) + (t.minutes ? t.minutes * 60 : 0) + (t.seconds ? t.seconds : 0)));

					if (t.total <= 0) {
						tree.set(["timers", "timerActive"], !allTimersComplete(tree, timersList));

						tree.set(["timers", timerKey, "enabled"], false);
						if (!objTimer.hasOwnProperty("suppressAudio") || !objTimer.suppressAudio) {
							speakTimerMessage(tree, timerKey);
						}
						handlePostTimerCompleteIfNoPushNotifications(objTimer, timerKey);
					}
				}
			}
		}
	}
}

function speakTimerMessage(tree, timerKey) {
	const _message = tree.get(["timers", timerKey, "action", "message"]);
	const message = _message && _message !== "" ? _message : "Timer Complete";
	tree.set(["timers", timerKey, "countdownTime"], message);
	tree.set(["timers", timerKey, "countdownSecondsRemaining"], 0);
	SyntheticVoiceApi.speak(message);
}

export function getTimeElapsed(startTime) {
	let t = Date.now() - startTime;
	// console.log("t", t);
	let seconds = Math.floor((t / 1000) % 60);
	let minutes = Math.floor((t / 1000 / 60) % 60);
	let hours = Math.floor((t / (1000 * 60 * 60)) % 24);
	let days = Math.floor(t / (1000 * 60 * 60 * 24));
	return {
		"total": t,
		"days": days,
		"hours": hours,
		"minutes": minutes,
		"seconds": seconds
	};
}
export function getTimeRemaining(endtime) {
	let t = Date.parse(endtime) - Date.parse(new Date());
	let seconds = Math.floor((t / 1000) % 60);
	let minutes = Math.floor((t / 1000 / 60) % 60);
	let hours = Math.floor((t / (1000 * 60 * 60)) % 24);
	let days = Math.floor(t / (1000 * 60 * 60 * 24));
	return {
		"total": t,
		"days": days,
		"hours": hours,
		"minutes": minutes,
		"seconds": seconds
	};
}

function handleElapsedTimerTick(tree) {
	// console.log(" In " + arguments.callee.name);
	if (flightTimerEnabled) {
		tree.set(["flightTimer", "elapsed"], moment.duration(((Date.now() - startTime) / 1000) / 60, "minutes").format("h [Hours]", 1));
	}
}

function getUrlForUserResource(path) {
	let urlPrefix = env.s3.contentBucketPrefix;
	if (!urlPrefix) {
		const _env = state.get(["env"]);
		if (_env) {
			urlPrefix = _.get(_env, "s3.contentBucketPrefix", null);
		}
	}
	return `${urlPrefix}${path}`;
}

let timerTemplatesFileCache = {};
let timerTemplatesCache = {};
function retrieveMissingTimer(identityId, timerKey) { // eslint-disable-line
	console.log("Fetching missing timers....", identityId, timerKey);
	// eslint-disable-next-line no-async-promise-executor
	return new Promise(async (resolve, reject) => {
		try {
			const fileKey = `${identityId}/timers/${timerKey}.json`;
			if (timerTemplatesCache[fileKey]) {
				resolve(timerTemplatesCache[fileKey]);
			} else {
				const url = getUrlForUserResource(`${identityId}/timers/${timerKey}.json`);
				console.log("About to fetch", url);
				const res = await fetch(url);
				if (res.ok) {
					// console.log("RES", res);
					const resJson = await res.json();
					timerTemplatesCache[fileKey] = resJson; // eslint-disable-line require-atomic-updates
					resolve(resJson);
				} else {
					// Try to get full inventory
					const fileKey = `${identityId}/timerTemplates.json`;
					const url = getUrlForUserResource(fileKey);
					// console.debug("Attemting a fetch on timer inventopry");
					let timerTemplates = timerTemplatesFileCache[fileKey];
					if (!timerTemplates) {
						const res = await fetch(url);
						timerTemplates = await res.json();
					}

					if (timerTemplates && _.isArray(timerTemplates)) {
						timerTemplatesFileCache[fileKey] = timerTemplates; // eslint-disable-line require-atomic-updates
						const result = _.find(timerTemplates, (o) => { return o.guid === timerKey; });
						if (result) {
							timerTemplatesCache[`${identityId}/timers/${timerKey}.json`] = result; // eslint-disable-line require-atomic-updates
							resolve(result);
						} else {
							reject({
								success: false,
								message: "Unable to find timer template in inventory",
								inventory: timerTemplates,
								timerKey,
								fileKey
							});
						}
					} else {
						reject({
							success: false,
							message: "The timer inventory is invalid, expected an array of timers",
							inventory: timerTemplates,
							timerKey,
							fileKey
						});
					}
				}

			}
		} catch (err) {
			console.warn("Failed to get timer templates (fatal error)", err);
			reject(err);
		}
	});
}